import { Box } from "@mui/material";
import NunitoText from "../general/NunitoText";

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 20 }}>
    <p
      style={{
        fontSize: 16,
        fontWeight: 700,
        color: "#144A94",
        margin: "0 0 6px 0",
      }}
    >
      {title}
    </p>
    <div style={{ fontSize: 15, color: "#333", lineHeight: 1.6 }}>
      {children}
    </div>
  </div>
);

export default function TeamBasedMembersFiltersHelpModal() {
  return (
    <Box
      className="popUpModal"
      style={{ width: 700, maxHeight: 680, overflowY: "auto" }}
      justifyContent={"flex-start !important"}
    >
      <NunitoText
        value="Filters Help"
        fontSize={28}
        fontWeight={600}
        color="#5E75C3"
        marginTop={30}
        marginBottom={20}
      />

      <div style={{ width: "100%", padding: "0 10px 20px" }}>
        <Section title="Event">
          Shows participants in the selected event (for example Math Warriors or
          Math Master Mind).
        </Section>

        <Section title="Division">
          Shows participants whose team belongs to the selected division (for
          example LP, UP, LS, US).
        </Section>

        <Section title="Award">
          Shows participants whose team has the selected final award.
        </Section>

        <Section title="In Team">
          <p style={{ margin: 0 }}>
            <strong>Yes</strong> — participants assigned to a team
          </p>
          <p style={{ margin: 0 }}>
            <strong>No</strong> — participants not assigned to any team
          </p>
        </Section>

        <Section title="Status">
          <p style={{ margin: 0 }}>
            <strong>Present</strong> — participants marked as present (not
            absent)
          </p>
          <p style={{ margin: 0 }}>
            <strong>Absent</strong> — participants marked as absent
          </p>
        </Section>

        <Section title="AES Uploaded">
          <p style={{ margin: "0 0 6px 0" }}>
            Shows whether answers have been uploaded for scoring purposes.
          </p>
          <p style={{ margin: 0 }}>
            <strong>Yes</strong> — answers are uploaded
          </p>
          <p style={{ margin: "0 0 6px 0" }}>
            <strong>No</strong> — answers are not uploaded
          </p>
          <p style={{ margin: 0, fontStyle: "italic", color: "#555" }}>
            Notes:
          </p>
          <ul
            style={{ listStyle: "none", margin: "4px 0 0 0", paddingLeft: 0 }}
          >
            <li>For Math Warriors, AES is checked per student.</li>
            <li>
              For Math Master Mind (and other team events), AES is checked at
              team level.
            </li>
            <li>
              An absent student is always treated as AES = No, even if answer
              data exists.
            </li>
          </ul>
        </Section>

        <Section title="Exceptional Cases">
          <p style={{ margin: "0 0 6px 0" }}>Special cases that need review:</p>
          <p style={{ margin: 0 }}>
            <strong>Absent With AES Uploaded</strong> — student is marked
            absent, but answer data still exists.
          </p>
          <p style={{ margin: 0 }}>
            <strong>AES Uploaded Without Answers</strong> — student has an AES
            row, but all answer cells are empty (Math Warriors only).
          </p>
        </Section>
      </div>
    </Box>
  );
}
